/* eslint-disable react/prop-types */
import { getState } from "../../../state/store";
import { selectAppTypesGroups } from "../../../state/selectors";

import { colors, strCode } from "../../../consts";
import { GradientLoader, TextOverflowWrapper } from "../../../components";
import { CellWrapper } from "../../../components/Table/styled";

const getAppNames = (apps) => {
  const appTypesGroups = selectAppTypesGroups()(getState());

  return apps
    ?.map((app) => {
      const appType = appTypesGroups.find((a) => a.appType === app);

      return appType?.name;
    })
    .join(", ");
};

export const MarketsTableColumns = [
  {
    Header: strCode.MARKET_CODE,
    accessor: "market",
    Cell: ({ cell, searchedText, cellWidth10, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth10}px`}>
          <TextOverflowWrapper
            highlightedText={searchedText}
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={120} height={24} animationDuration={32} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.MARKET_NAME,
    accessor: "name",
    Cell: ({ cell, cellWidth8, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth8}px`}>
          <TextOverflowWrapper
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={32} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.COUNTRY_TITLE,
    accessor: "country",
    Cell: ({ cell,  isLoading }) => {
      return (
        <CellWrapper width="272px">
          <TextOverflowWrapper
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={140} height={24} animationDuration={32} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ACTIVE_USERS,
    accessor: "activeUserCount",
    Cell: ({ cell, isLoading }) => {
      return (
        <CellWrapper width="122px">
          <TextOverflowWrapper
            style={{
              width: "100%",
              textAlign: "end",
              color: colors.RAISIN_70,
              paddingRight: "36px"
            }}>
            {isLoading ? (
              <GradientLoader width={84} height={24} animationDuration={40} />
            ) : (
              cell.value
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  },
  {
    Header: strCode.ACTIVE_APPS,
    accessor: "activeAppTypes",
    Cell: ({ cell, cellWidth3, isLoading }) => {
      return (
        <CellWrapper width={`${cellWidth3}px`}>
          <TextOverflowWrapper
            style={{
              color: colors.RAISIN_70
            }}>
            {isLoading ? (
              <GradientLoader width={510} height={24} animationDuration={40} />
            ) : (
              getAppNames(cell.value)
            )}
          </TextOverflowWrapper>
        </CellWrapper>
      );
    }
  }
];
